import PropTypes from 'prop-types'

/*
  Helpers for the canonical post-2020 Norwegian fylker.

  The list itself is NOT hardcoded here - it comes from GET /api/v1/location/fylker, which the
  backend derives from the same kommune dataset the artist search matches against. That keeps the
  values the picker offers from ever drifting from the ones `fylke` accepts. These functions are
  pure: pass them the list from the store (getFylkerSelector / getFylkeNamesSelector).

  Do not rebuild this list from /api/v1/location/getLocations - that returns pre-2020 fylke names
  (Hordaland, Sogn og Fjordane, Hedmark, ...) which the search rejects.
*/

// 'Møre' and 'More' should both match - fold the Norwegian characters for comparison only.
const fold = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/ø/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/å/g, 'a')

/*
  Canonical spelling of a fylke, or '' when it is not one. Used to validate values arriving from
  a url before they reach the backend - an unrecognised fylke returns an empty result set rather
  than an error, so it has to be dropped up front.
*/
export const getCanonicalFylke = (fylkeNames, name) => {
  const needle = fold(name)
  if (!needle) return ''
  const match = (fylkeNames || []).find(fylkeName => fold(fylkeName) === needle)
  return match || ''
}

export const isValidFylke = (fylkeNames, name) => !!getCanonicalFylke(fylkeNames, name)

export const searchFylker = (fylkeNames, query, limit = 5) => {
  const needle = fold(query)
  if (!needle) return []
  const startsWith = []
  const contains = []
  ;(fylkeNames || []).forEach(name => {
    const haystack = fold(name)
    if (haystack.indexOf(needle) === 0) {
      startsWith.push(name)
    } else if (haystack.indexOf(needle) !== -1) {
      contains.push(name)
    }
  })
  return startsWith.concat(contains).slice(0, limit)
}

export const FylkeShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  kommuneCount: PropTypes.number,
  primary: PropTypes.bool,
})
